<template>
  <div class="text-string"
       v-html="textResult"
       @click="triggerClick"></div>
</template>

<script>
  import Language from '@/contexts/language/locales/en';

  export default {
    name: "text-string",
    mixins: [Language],
    props: {
      labelId: {type: String},
      props: {type: Object}
    },
    computed: {
      textResult() {
        return this.getText(this.labelId, this.props);
      }
    },
    methods: {
      triggerClick() {
        this.$emit('handleClick');
      }
    }
  }
</script>

<style scoped>

</style>